import { memo } from 'react'

import { ConfirmationDialog } from '@collaborate-health/uikit'
import { trainingMaterialTitleFormatter } from '@tabeeb/shared/utils/text'

export interface ContentTrainingMaterialDetachConfirmationDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
}

const ContentTrainingMaterialDetachConfirmationDialog: React.FC<
  ContentTrainingMaterialDetachConfirmationDialogProps
> = ({ open, onClose, onSubmit }) => {
  return (
    <ConfirmationDialog
      isOpen={open}
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      title={trainingMaterialTitleFormatter.format('Are you sure you want to detach training material?')}
      submitButtonColor='error'
      submitButtonText='Detach'
    />
  )
}

export default memo(ContentTrainingMaterialDetachConfirmationDialog)

